import styled from "styled-components";


export const StyledAddAllergyModalContent = styled.div`
  .form {
    margin-top: 0;
  }
`;
